export const environment = {
  production: false,
  environmentName: 'dev',
  adminSvcUrl: 'https://dev5.paydatasync.com/AdminService/api/',
  broadcastingUrl: 'https://dev5.paydatasync.com/AdminService',
  broadcastingUrl2: 'https://dev5.paydatasync.com/SignalR',
  hubName: 'signalr',
  resourceSvcUrl: 'https://dev5.paydatasync.com/ResourceService/api/',
  dwollaSvcUrl: 'https://dev5.paydatasync.com/DwollaProxyAPI/api/',
  //crmProxyApiUrl: 'https://devint.paydatasolutions.com/CRMPRoxyAPI/API/',
  broadcastingEnabled: true,
  broadcastingMaxReconnectCount: 9999,
  portalCode: 'PAP',
  loginIframeURL: '',
  showFakeCard: true,
  oktaLoginURL:
    'https://thecheesecakefactory.okta.com/app/thecheesecakefactory_frcgratsync_1/exk10iu068zNSrLfV1t8/sso/saml',
  persistAuthOnRefresh: false,
};
